/**
 * La cellule « Client » d'une ligne de devis.
 *
 * ── UN DEVIS SANS CLIENT SE VOIT — 28 août 2026 ──
 *
 * Depuis qu'un devis peut naître d'un mail sans que l'entreprise ait
 * été reconnue, une cellule vide serait indiscernable d'une colonne
 * mal remplie. Le manque nomme donc le GESTE qui le lève — comme
 * « À estimer » et « À compléter » sur les pièces, et pour la même
 * raison : un signal se voit et se corrige, une absence ne se voit pas.
 */
export default function ClientCell({ devis }) {
  if (devis.client_company) return devis.client_company;
  return <span className="devis-sans-client">Client à rattacher</span>;
}
